import { Button, Drawer, Space } from "antd";
import Menu from "./Menu";
import { MenuUnfoldOutlined } from "@ant-design/icons";

const MobileMenuDrawer = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {


  const onClose = () => {
    setOpen(false);
  };

  return (
    <Drawer
     title={
        <img
          src={"/svg_logo.svg"}
          alt="Logo"
          className="w-40 h-16 object-contain"
        />
      }
      placement={"left"}
      closable={false}
      onClose={onClose}
      className=" block sm:hidden "
      width={250}
      open={open}
      key={"left"}
      extra={
        <Space>
          <Button
            type="text"
            className="rounded-full bg-grey hover:bg-primary"
            onClick={onClose}
            icon={
              <MenuUnfoldOutlined className=" !text-[12px] sm:!text-[15px]" />
            }
          />
        </Space>
      }
    >
      <Menu onClose={onClose}/>
    </Drawer>
  );
};

export default MobileMenuDrawer;
